const SubscriptionTrialStatus = {
  STARTED: 'started',
  ENDED: 'ended',
} as const;

export default SubscriptionTrialStatus;
